import APICall from '../utils/APICall';

export default class  ScheduledServices {
       static listSchedules = async (page, pageLimit, search,from, to,transferStatus, transferType) => {
        return await APICall(`/api/Transfer/admin/list-scheduled-transfers?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}&transferStatus=${transferStatus}&transferType=${transferType}`, "GET");
    }
    static viewSchedule = async (transferId) => {
        return await APICall(`/api/Transfer/admin/view-scheduled-transfer/${transferId}`, "GET");
    }
    static exportSchedule = async (search,from, to, transferStatus, transferType) => {
        return await APICall(`/api/Transfer/admin/export-schedule-transfer?search=${search}&from=${from}&to=${to}&transferStatus=${transferStatus}&transferType=${transferType}`, "GET");
    }
}